module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-bank-lukas.e7308def.jpg";